import apiClient from './axiosInstance';


export const getUserRoles = async (uid) => {
    return await apiClient.get(`/user-role/${uid}`);
  };
  
